// Gets the window.analytics object and returns it; must be function to ensure
// we have the latest analytics object, not a capture in an unknown state
//
export default () => {
  const root = typeof global === 'object' ? global : window;
  return root.analytics;
};
